import React, { useContext, useEffect, useState } from 'react';
import iframeContext, { IIframeContext } from '../../contexts/IframeContext';
import { FrameData } from '../../components/FrameData';
import { RouteComponentProps } from 'react-router-dom';
import { prefix } from '../../router';
import { useToast } from '../../hooks/toast';
import { getItemInStorage, useLocalStorage } from '../../hooks/useLocalStorage';
import {
  findOnePontoServicoByEtiqueta,
  findOnePontoServicoByEtiquetaAnonimo,
} from '../../api/services/OcorrenciaPublica';

const IframePoint = ({ history }: RouteComponentProps) => {
  const { setIframeState } = useContext<IIframeContext>(iframeContext);
  const [loadingPage, setLoadingPage] = useState(false);
  const [codParqueServico] = useLocalStorage<number>('cod_parque_servico', -1);
  const [redirectCodPontoServico, setRedirectCodPontoServico] = useLocalStorage<number>(
    'redirect_cod_ponto_servico',
    -1,
  );
  const [redirectEtiquetaPonto, setRedirectEtiquetaPonto] = useLocalStorage<string>('redirect_etiqueta_ponto', '');
  const toast = useToast();

  function clearRedirectData() {
    setRedirectCodPontoServico(-1);
    setRedirectEtiquetaPonto('');
  }

  useEffect(() => {
    async function preparePontoOcorrencia() {
      if (!redirectCodPontoServico || redirectCodPontoServico === -1 || !redirectEtiquetaPonto || !codParqueServico) {
        history.push(`${prefix}/generate`);
        return;
      }

      setLoadingPage(true);

      const response = getItemInStorage('accessToken')
        ? await findOnePontoServicoByEtiqueta(redirectEtiquetaPonto)
        : await findOnePontoServicoByEtiquetaAnonimo(redirectEtiquetaPonto);

      if (response.err || !response.resp) {
        toast.addToast({
          type: 'warn',
          description: response.err || 'Não foi possível localizar o ponto para gerar a ocorrência.',
        });
        clearRedirectData();
        history.push(`${prefix}/generate`);
        return;
      }

      const pontoServico = response.resp;

      if (
        Number(pontoServico.seq_ponto_servico) !== Number(redirectCodPontoServico) ||
        Number(pontoServico.cod_parque_servico) !== Number(codParqueServico)
      ) {
        toast.addToast({
          type: 'warn',
          description: 'O ponto informado não pertence ao parque de serviço atual.',
        });
        clearRedirectData();
        history.push(`${prefix}/generate`);
        return;
      }

      const dadosCadastroOcorrencia = {
        ocorrencia: {
          cod_parque_servico: pontoServico.cod_parque_servico,
          cod_municipio: pontoServico.cod_municipio,
          cod_tipo_origem_ocorrencia: 5,
        },
        ocorrenciasPontoServico: [
          {
            nom_endereco_livre: pontoServico.nom_endereco,
            cod_ponto_servico: pontoServico.seq_ponto_servico,
            cod_bairro: pontoServico.cod_bairro,
            cod_municipio: pontoServico.cod_municipio,
            json_ocorrencia_ponto_servico: {
              coords: {
                latitude: pontoServico.latitude,
                longitude: pontoServico.longitude,
              },
              endereco: {},
              imagens: [{ nom_caminho_imagem: null }],
            },
          },
        ],
      };

      if (setIframeState) {
        setIframeState((oldValue) => ({ ...oldValue, dadosCadastroOcorrencia } as any));
      }

      clearRedirectData();
      history.replace(`${prefix}/generate/address/send`);
    }

    void preparePontoOcorrencia();
  }, []);

  return <FrameData loading={loadingPage} />;
};

export default IframePoint;
